import React from 'react';
import Breakpoint from '../../components/responsiveUtilities/breakpoint';

// eslint-disable-next-line react/prop-types
const Footer = ({ link }) => (
  <div className="u-pb-30 u-mt-4 u-text-small u-co-grey--light u-ta-center">
    <Breakpoint name="phone">
      To manage<br className="u-hide-on-desktop" /> notifications,&nbsp;
      <a className="u-co-grey--light u-td-underline u-co-black-2" href={link} target="_blank">click here</a>.
    </Breakpoint>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/Footer.jsx